import { useTranslation } from 'react-i18next';

/**
 * "No reading", where the screen shows a dash.
 *
 * An em dash is not speech. No synthesiser voices one, so a sensor readout waiting for a fix was
 * announced as "Latitude, Longitude" with silence between, and Angle's as the bare word "degrees" —
 * a student is told nothing at all, which reads as a bug rather than as a state.
 *
 * The dash stays on screen, `aria-hidden`: it is instantly legible, it holds the line's height, and
 * it is what every other readout in the app uses for "nothing yet". The words go beside it.
 *
 * Wraps the dash rather than replacing it so callers keep their own formatting — GPS's placeholder
 * carries an axis label, Compass's carries a degree sign, and neither should have to rebuild it.
 */
export function SpokenPlaceholder({ children }: { children: React.ReactNode }) {
  const { t } = useTranslation();
  return (
    <>
      <span aria-hidden='true'>{children}</span>
      <span className='sr-only'>{t('blocks.sensorSource.readoutNoReading')}</span>
    </>
  );
}
